import React, { useEffect, useRef, useState } from 'react';
import { Animated, Easing, Image, StyleSheet, View, Platform } from 'react-native';

type BrandSplashProps = {
  animateOut?: boolean;
  onFinish?: () => void;
};

const BrandSplash = ({ animateOut = false, onFinish }: BrandSplashProps) => {
  const fade = useRef(new Animated.Value(1)).current;
  const scale = useRef(new Animated.Value(0.94)).current;
  const [webHidden, setWebHidden] = useState(false);


  useEffect(() => {
    if (Platform.OS === 'web' && !animateOut) {
      const timer = setTimeout(() => {
        setWebHidden(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [animateOut]);

  // Hide immediately if this is the web and we've waited
  if (Platform.OS === 'web' && webHidden) {
    return null;
  }

  useEffect(() => {
    const intro = Animated.sequence([
      Animated.timing(scale, {
        toValue: 1.08,
        duration: 700,
        easing: Easing.out(Easing.ease),
        useNativeDriver: Platform.OS !== 'web',
      }),
      Animated.timing(scale, {
        toValue: 1,
        duration: 450,
        easing: Easing.inOut(Easing.ease),
        useNativeDriver: Platform.OS !== 'web',
      }),
    ]);

    intro.start();

    return () => {
      intro.stop();
    };
  }, [scale]);

  useEffect(() => {
    if (!animateOut) {
      return;
    }

    const exit = Animated.sequence([
      Animated.delay(400),
      Animated.parallel([
        Animated.timing(fade, {
          toValue: 0,
          duration: 450,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: Platform.OS !== 'web',
        }),
        Animated.timing(scale, {
          toValue: 1.12,
          duration: 450,
          easing: Easing.out(Easing.ease),
          useNativeDriver: Platform.OS !== 'web',
        }),
      ]),
    ]);

    exit.start(({ finished }) => {
      if (finished) {
        onFinish?.();
      }
    });

    return () => {
      exit.stop();
    };
  }, [animateOut, fade, onFinish, scale]);

  return (
    <Animated.View
      style={[
        styles.container,
        animateOut ? StyleSheet.absoluteFillObject : styles.fillScreen,
        { opacity: fade },
      ]}
    >
      <Animated.View style={{ transform: [{ scale }] }}> 
        <Image source={require('../../../assets/lnb_newlogo.png')} style={styles.logoImage} />
      </Animated.View>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    zIndex: 99,
    backgroundColor: '#000000',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fillScreen: {
    flex: 1,
  },
  logoImage: {
    width: 120,
    height: 120,
    resizeMode: 'contain',
  },
});

export default BrandSplash;
